import React, { Component } from "react";
import { Alert } from "reactstrap";
import PropTypes from "prop-types";
import AutocompleteCompany from "../common/autocomplete_company";
import ExperieneceForm from "./experience_form";
import InvalidFeedback from "../../../common/invalid_feedback";

class CareerForm extends Component {
  constructor(props) {
    super(props);

    this.initialCompany = {
      id: null,
      name: "",
      website_url: "",
      logo_image: "",
      errors: {}
    };

    this.initialExperience = {
      id: "",
      title: "",
      start_date: "",
      end_date: "",
      current: false,
      description: "",
      errors: {},
      _destroy: false
    };

    this.initialCareer = {
      id: "",
      experiences_attributes: [ Object.assign({}, this.initialExperience) ]
    };

    this.isEditing = Boolean(props.career);

    if (this.isEditing) {
      Object.assign(this.initialCompany, props.career.company);
      Object.assign(this.initialCareer, {
        id: props.career.id,
        experiences_attributes: props.career.experiences.map(
          experience => Object.assign({}, this.initialExperience, experience)
        )
      });
    }

    this.state = {
      company: Object.assign({}, this.initialCompany),
      career: Object.assign({}, this.initialCareer),
      previewLogoImage: {
        file_name: "画像ファイルの選択",
        url: ""
      },
      isSaving: false,
      isShown: false,
      isEditing: this.isEditing,
      errorMessage: ""
    };
  }

  onCompanyChange = (event, value) => {
    const { company } = this.state;
    const field = event.target.name;
    company[field] = value == null ? event.target.value : value;
    this.setState({company: company});
  }

  onExperienceChange = (event, experience, value) => {
    const { career } = this.state;
    const field = event.target.name;
    experience[field] = value == null ? event.target.value : value;
    this.setState({career: career});
  }

  onCompanyLogoImageChange = (event) => {
    const file = event.target.files[0];
    const file_name = event.target.value.replace(/\\/g, "/").replace(/.*\//, "");

    this.onCompanyChange(event, file);

    if (!file) return;
    if (/^image/.test(file.type)) {
      const reader = new FileReader();
      reader.onloadend = () => {
        this.setState({previewLogoImage: {file_name: file_name, url: reader.result}});
      };
      reader.readAsDataURL(file);
    }
  }

  setCompany = (company) => {
    this.setState({company: company});
  }

  handleFormSubmit = (event) => {
    event.preventDefault();
    this.setState({isSaving: true});

    const { actions } = this.props;
    const { career, isEditing } = this.state;

    if (isEditing) {
      actions.updateCareer(career).then(() => {
        const { handleCareerEditButtonClick } = this.props;
        handleCareerEditButtonClick();
      }).catch(response => {
        this.setState({
          career: response.career,
          isSaving: false
        });
      });
    } else {
      actions.addCareer(this.state).then(() => {
        const { handleEditModeLinkClick } = this.props;
        handleEditModeLinkClick();
      }).catch(response => {
        this.setState({
          errorMessage: response.message,
          company: response.company,
          career: response.career,
          isSaving: false
        });
      });
    }
  }

  handleAddExperience = () => {
    const { career } = this.state;
    career.experiences_attributes.push(Object.assign({}, this.initialExperience));
    this.setState({career: career});
  }

  handleRemoveExperience = (experience) => {
    const { career, isEditing } = this.state;

    if (isEditing) {
      experience._destroy = true;
    } else {
      career.experiences_attributes.pop();
    }

    this.setState({career: career});
  }

  updateShown = (flag) => {
    this.setState({isShown: flag});
  }

  render () {
    const { defaultCompanyImage, handleEditModeLinkClick, handleCareerEditButtonClick } = this.props;
    const { company, career, previewLogoImage, isSaving, isShown, isEditing, errorMessage } = this.state;

    return (
      <form>
        { errorMessage && (
          <Alert color='danger' className='popup'>
            <p>{errorMessage}</p>
          </Alert>
        )}
        <div className='add-company new-career'>
          <div className='form-group row'>
            <label className='col-12 col-md-3 col-form-label' htmlFor='company_name'>会社名</label>
            <div className='col-12 col-md-9'>
              <AutocompleteCompany
                company={company}
                disabled={Boolean(career.id)}
                defaultCompanyImage={defaultCompanyImage}
                updateShown={this.updateShown}
                setCompany={this.setCompany}
              />
            </div>
          </div>

          { isShown == true && (
            <React.Fragment>
              <div className='form-group row'>
                <label className='col-12 col-lg-3 col-form-label' htmlFor='company_website_url'>WebサイトURL</label>
                <div className='col-12 col-lg-9'>
                  <input
                    name='website_url'
                    className={`${company.errors.website_url ? "form-control is-invalid" : "form-control"}`}
                    type='text'
                    value={company.website_url}
                    placeholder='https://yourcompany.com'
                    id='company_website_url'
                    onChange={this.onCompanyChange}
                  />
                  <InvalidFeedback errors={company.errors.website_url} label='WebサイトURL' />
                </div>
              </div>

              <div className='form-group row mb-4'>
                <label className='col-12 col-lg-3 col-form-label' htmlFor='company_logo_image'>ロゴ</label>
                <div className='col-12 col-lg-9'>
                  <div className='custom-file mb-3'>
                    <input
                      name='logo_image'
                      className={`${company.errors.logo_image ? "custom-file-input is-invalid" : "custom-file-input"}`}
                      type='file'
                      id='company_logo_image'
                      onChange={this.onCompanyLogoImageChange}
                    />
                    <label className='custom-file-label' htmlFor='company-logo-image'>
                      {previewLogoImage.file_name}
                    </label>
                    <InvalidFeedback errors={company.errors.logo_image} />
                  </div>
                  <img
                    src={previewLogoImage.url || defaultCompanyImage}
                    alt="ロゴ"
                    className='logo-preview'
                  />
                </div>
              </div>
            </React.Fragment>
          )}

          <ExperieneceForm
            career={career}
            onExperienceChange={this.onExperienceChange}
            handleRemoveExperience={this.handleRemoveExperience}
          />

          <div className='form-group row mb-4'>
            <div className='col-12'>
              <button type='button' className='btn-profile-edit' onClick={this.handleAddExperience}>
                <span>
                  <i className='fas fa-plus pr-1' />
                  役職の追加
                </span>
              </button>
            </div>
          </div>

          <div className='form-group row'>
            <div className='col-12'>
              <input
                type='button'
                disabled={isSaving}
                value={isSaving ? "保存中..." : "保存"}
                className='btn btn-primary float-right'
                onClick={this.handleFormSubmit}
              />
              <input
                type='button'
                disabled={isSaving}
                value='キャンセル'
                className='btn btn-white-primary float-right mr-2'
                onClick={isEditing ? handleCareerEditButtonClick : handleEditModeLinkClick}
              />
            </div>
          </div>
        </div>
      </form>
    );
  }
}

CareerForm.propTypes = {
  career: PropTypes.shape({
    id: PropTypes.number.isRequired,
    company: PropTypes.object.isRequired,
    experiences: PropTypes.arrayOf(PropTypes.object).isRequired,
  }),
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
  handleCareerEditButtonClick: PropTypes.func,
  handleEditModeLinkClick: PropTypes.func,
  defaultCompanyImage: PropTypes.string.isRequired
};

CareerForm.defaultProps = {
  career: null,
  handleCareerEditButtonClick: () => {},
  handleEditModeLinkClick: () => {}
};

export default CareerForm;
